export default __webpack_public_path__ + "static/IN-9408v9008_resTestBig3-6583ca9e12882ff704c592c2d813ea10.webp";